/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Reply_Incomplete_HintInputs */

const en_error_nav_reply_incomplete_hint = /** @type {(inputs: Error_Nav_Reply_Incomplete_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review the reply and mark as complete if done.`)
};

const fr_error_nav_reply_incomplete_hint = /** @type {(inputs: Error_Nav_Reply_Incomplete_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revoyez la reponse et marquez-la comme terminee si fait.`)
};

const de_error_nav_reply_incomplete_hint = /** @type {(inputs: Error_Nav_Reply_Incomplete_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prüfen Sie die Antwort und markieren Sie sie als erledigt, falls Sie damit fertig sind.`)
};

const it_error_nav_reply_incomplete_hint = /** @type {(inputs: Error_Nav_Reply_Incomplete_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rivedi la risposta e, se completata, contrassegnala come completa.`)
};

const ru_error_nav_reply_incomplete_hint = /** @type {(inputs: Error_Nav_Reply_Incomplete_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Просмотрите ответ и отметьте его как выполненный, если он завершен.`)
};

const es_error_nav_reply_incomplete_hint = /** @type {(inputs: Error_Nav_Reply_Incomplete_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revise la respuesta y marque como completa si está completa.`)
};

const zh_cn2_error_nav_reply_incomplete_hint = /** @type {(inputs: Error_Nav_Reply_Incomplete_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请检查回复内容，如果已完成，请标记为已完成。`)
};

const ja_error_nav_reply_incomplete_hint = /** @type {(inputs: Error_Nav_Reply_Incomplete_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返信を確認し、完了した場合は完了としてマークします。`)
};

const hi_error_nav_reply_incomplete_hint = /** @type {(inputs: Error_Nav_Reply_Incomplete_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उत्तर की समीक्षा करें और पूरा होने पर उसे पूर्ण के रूप में चिह्नित करें।`)
};

const pt_pt2_error_nav_reply_incomplete_hint = /** @type {(inputs: Error_Nav_Reply_Incomplete_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analise a resposta e marque-a como concluída se estiver tudo certo.`)
};

/**
* | output |
* | --- |
* | "Review the reply and mark as complete if done." |
*
* @param {Error_Nav_Reply_Incomplete_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_reply_incomplete_hint = /** @type {((inputs?: Error_Nav_Reply_Incomplete_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Reply_Incomplete_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_nav_reply_incomplete_hint(inputs)
	if (locale === "de") return de_error_nav_reply_incomplete_hint(inputs)
	if (locale === "it") return it_error_nav_reply_incomplete_hint(inputs)
	if (locale === "ru") return ru_error_nav_reply_incomplete_hint(inputs)
	if (locale === "es") return es_error_nav_reply_incomplete_hint(inputs)
	if (locale === "zh-CN") return zh_cn2_error_nav_reply_incomplete_hint(inputs)
	if (locale === "ja") return ja_error_nav_reply_incomplete_hint(inputs)
	if (locale === "hi") return hi_error_nav_reply_incomplete_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_error_nav_reply_incomplete_hint(inputs)
	return en_error_nav_reply_incomplete_hint(inputs)
});